import React from 'react';
import { css } from '@emotion/react';
import { Popup } from '$/components/ui/Popup';
import { PermissionedLink } from '$/components/Router';
import { rolesPermissionsMatrix } from '$/shared/frontend/rolesPermissionsMatrix';

export const RolePopup: React.FC = () => {
  return (
    <Popup
      content={
        <>
          <table
            css={css`
              border: 0;
              td {
                vertical-align: top;
              }
              td:first-of-type {
                text-align: right;
                padding-right: 0.5rem;
                text-align:;
              }
            `}
          >
            <tbody>
              <tr>
                <td>Admin</td>
                <td>Can manage eWebinars, settings & billing</td>
              </tr>
              <tr>
                <td>Creator</td>
                <td>Able to create and edit eWebinars</td>
              </tr>
              <tr>
                <td>Editor</td>
                <td>Able to edit eWebinars they're assigned to</td>
              </tr>
              <tr>
                <td>Moderator</td>
                <td>Can chat with attendees of eWebinars they're assigned to</td>
              </tr>
              <tr>
                <td>Presenter</td>
                <td>Used only to display presenter info during eWebinar</td>
              </tr>
            </tbody>
          </table>
          <p className='mt-2'>
            Admins have permission to update team members' roles on the{' '}
            <PermissionedLink to={rolesPermissionsMatrix.accountTeam.path}>
              Team page
            </PermissionedLink>
            .
          </p>
        </>
      }
      key='Role'
    />
  );
};
